import { Flex } from '@everlywell/ui-kit';
import DateField from 'components/FormFields/DateField';
import InputField from 'components/FormFields/InputField';
import SelectField from 'components/FormFields/SelectField';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { ALl_STATES } from 'utils/stateAbbreviations';

export type PersonalDataFormProps = {};

export type PrePurchaseQuizPersonalData = {
  personalData: {
    firstName: string;
    lastName: string;
    dob: string;
    state: string;
  };
};

/**
 * This component adds the personal data form fields to the pre-purchase quiz modal.
 */
function PersonalDataForm(props: PersonalDataFormProps): JSX.Element {
  const { register } = useFormContext();

  // TODO: move content to contentful and fetch it from there
  return (
    <Flex flexDirection="column" gap={3} marginTop={[4, 6]}>
      <Flex flexDirection={['column', null, 'row']} gap={4}>
        <InputField
          ref={register}
          label="First name"
          placeholder="Jane"
          name="personalData.firstName"
          validations={{
            required: 'First name is a required field',
          }}
        />
        <InputField
          ref={register}
          label="Last name"
          placeholder="Smith"
          name="personalData.lastName"
          validations={{
            required: 'Last name is a required field',
          }}
        />
      </Flex>
      <Flex flexDirection={['column', null, 'row']} gap={4}>
        <DateField
          ref={register}
          label="Date of birth"
          placeholder="MM/DD/YYYY"
          name="personalData.dob"
          requiredConfig="DOB is a required field"
          maxAgeConfig={{
            value: 75,
            message: 'You must be less than 75 years old',
          }}
        />
        <SelectField
          ref={register}
          label="Which state will you access our services from?"
          placeholder="State"
          aria-label="State"
          name="personalData.state"
          options={ALl_STATES}
          renderOption={({ id: abbr, value: name }) => (
            <option key={abbr} value={abbr}>
              {name}
            </option>
          )}
          validations={{
            required: 'State is a required field',
          }}
        />
      </Flex>
    </Flex>
  );
}

export default PersonalDataForm;
